'use client';

import { MobileIcon } from '@/components/icons';
import { CloseIconThin } from '@/components/icons';
import { useAuthModal } from '@/lib/context/AuthModalContext';
import { ButtonClassic } from '@/components/buttons/ButtonClassic';
import { usePathname } from 'next/navigation';

interface IUserAuthForm {
  handleClose: () => void;
}

export const MobileRegisterNotification = ({ handleClose }: IUserAuthForm) => {
  const { openModal: openAuthModal } = useAuthModal();
  const pathname = usePathname();

  const handleClick = () => {
    openAuthModal('register', 'provider');
    setTimeout(() => {
      handleClose();
      if (document) {
        document.body.style.overflow = 'hidden';
      }
    }, 200);
  };

  return (
    <div className="bg-gray-800 rounded-2xl">
      <div className="flex flex-row justify-end items-end px-4">
        <div className="modal__close cursor-pointer" onClick={handleClose}>
          <CloseIconThin />
        </div>
      </div>

      <div className="flex flex-col items-center text-center gap-10 p-8 pt-6">
        <div className="flex flex-col items-center gap-2">
          <MobileIcon />
          <h3 className="text-lg mb-0">Adding a tour is currently available as a desktop feature.</h3>
          <p className="text-sm font-light mb-0">
            You can still register and see and accept
            <br /> reservations
            <br />
            as a tour operator on your phone.
          </p>
        </div>
        {pathname.includes('register') && (
          <ButtonClassic className="btn" handleClick={handleClick}>
            Continue to registration
          </ButtonClassic>
        )}
      </div>
    </div>
  );
};
